// Libs
import { amplitudeEventLogger } from "@collectivehealth/frontend-analytics";
import { useEffect } from "react";
import { useLastLocation } from "react-router-last-location";
import { useRouteMatch, matchPath } from "react-router-dom";

// Utils
import {
  getMatchParam,
  getMatchPath,
  joinPageTitleParts,
  getAnyRouteParam
} from "utils/routing/routing";
import { getMedicalClinicalCopy } from "utils/copy/copy";

// Constants
import { USER_EVENTS } from "constants/analytics";
import { ROUTE_CONFIGS, ROUTE_PARAMS, ROUTE_TO_PAGE_TITLE_MAP } from "constants/routing";

export default function usePageEnteredLogger(category, paramToLog) {
  const match = useRouteMatch();
  let matchParam = getMatchParam(match, paramToLog);
  if (matchParam && paramToLog === ROUTE_PARAMS.CLINICAL_ID) {
    matchParam = getMedicalClinicalCopy(matchParam);
  }
  const lastLocation = useLastLocation() || {};

  useEffect(() => {
    let lastMatch;

    Object.values(ROUTE_CONFIGS).some(config => {
      lastMatch = matchPath(lastLocation.pathname, { path: config.path, exact: true });
      return lastMatch !== null;
    });

    // the paramToLog for the last match isn't necessarily the same as the
    // the current match, so we check for any
    let { value: lastParam, name: lastParamType } = getAnyRouteParam(lastMatch);
    if (lastParam && lastParamType === ROUTE_PARAMS.CLINICAL_ID) {
      lastParam = getMedicalClinicalCopy(lastParam);
    }

    amplitudeEventLogger(USER_EVENTS.PAGE_ENTERED, {
      category,
      newPage: joinPageTitleParts(ROUTE_TO_PAGE_TITLE_MAP[getMatchPath(match)], matchParam),
      previousPage: joinPageTitleParts(ROUTE_TO_PAGE_TITLE_MAP[getMatchPath(lastMatch)], lastParam)
    });
    // This effect should only run on componentDidMount or when logged params change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramToLog, matchParam]);
}
